import React, { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react';

import { PartnerArray } from '../History';

export interface SelectedPartnersContextData {
  partners?: PartnerArray;
  setPartners?: Dispatch<SetStateAction<PartnerArray>>;
}

export const SelectedPartnersContext = createContext<SelectedPartnersContextData>({});

export interface SelectedPartnersProviderProps {
  children: ReactNode;
}

export function SelectedPartnersProvider({ children }: SelectedPartnersProviderProps) {
  const [partners, setPartners] = useState<PartnerArray>();

  return (
    <SelectedPartnersContext.Provider value={{ partners, setPartners }}>{children}</SelectedPartnersContext.Provider>
  );
}
